<script>
import MemberMerchantPicker from '@components/MemberMerchantPicker'
import ModalMemberSetting from '@components/ModalMemberSetting'

export default {
  components: {
    MemberMerchantPicker,
    ModalMemberSetting,
  },
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultAvatar: require('@assets/images/avatar_default.jpg'),
      defaultImg: require('@assets/images/activity_default.png'),
      merchantLevel: '',
      merchantLevelList: [],
      isMerchantPickerActive: false,
      isModalMemberSettingActive: false,
    }
  },
  computed: {
    greetingName() {
      if(this.member && this.member.fullName && this.member.gender) {
        const genderTitleMap = {
          male: this.$t('global.GREETING_MALE' /* 先生 */, {
            name: this.member.fullName,
          }),
          female: this.$t('global.GREETING_FEMALE' /* 小姐 */, {
            name: this.member.fullName,
          }),
        };

        return genderTitleMap[this.member.gender]
      }else {
        return this.$t('global.NAME' /* 姓名 */)
      }
    },
  },
  created() {
    this.getMerchantLevel();
  },
  methods: {
    getMerchantLevel() {
      this.merchantLevelList = this.member.levels.map(item => {
        return {
          text: item.merchantName,
          value: item
        }
      });

      this.member.levels.forEach(item => {
        if( this.$route.query.merchant === item.merchantAlias) {
          this.merchantLevel = item
        }
      })
    },
    handlerMerchantLevel(value) {
      if(this.$route.name === 'member-order' || this.$route.name === 'member-prepaid') {
        this.$router.push({
          query: {
            ...this.$route.query,
            p: 1,
            merchant: value.merchantAlias
          }
        })
      }else {
        this.$router.push({
          query: {
            ...this.$route.query,
            merchant: value.merchantAlias
          }
        })
      }
    }
  }
}
</script>
<template>
  <div v-if="member" class="booking-section" >
    <div class="subsection member-wrapper">
      <div
        class="columns"
        :class="$style.member"
      >
        <div class="column" :class="$style['member-left']">
          <div class="media is-align-items-stretch">
            <figure class="media-left">
              <picture :class="$style['member-avatar']">
                <BaseImage :src="defaultAvatar" :error-src="defaultAvatar" class-name="is-cover" />
              </picture>
            </figure>
            <div class="media-content">
              <div>
                <div
                  :class="$style['member-content__name']"
                  class="content is-size-5 has-text-weight-medium"
                >{{greetingName}}</div>
                <div class="has-text-grey-light">{{member.phone}}</div>
              </div>
              <div class="is-link-primary" @click="isModalMemberSettingActive = true" >{{$t('global.EDIT_INFORMATION' /*編輯個人資訊*/)}}
                <BaseIcon name="pen" /></div>
            </div>
          </div>
        </div>
        <div class="column" :class="$style['member-right']">
          <div class="column is-full" style="padding: 0">
            <div class="columns is-multiline">
              <div class="column is-full">
                <b-button
                  outlined
                  rounded
                  style="justify-content: flex-start"
                  class="is-select-style is-fullwidth"
                  @click="isMerchantPickerActive = true"
                >{{merchantLevel.merchantName || $t('global.MERCHANT_ALL' /* 全部商家 */)}}</b-button>
              </div>
              <div v-if="merchantLevel" class="column">
                <div class="media is-align-items-stretch">
                  <figure class="media-left">
                    <router-link :to="{ name: 'booking',
                    params: { merchantAlias: merchantLevel.merchantAlias },query: { language:
                    this.$route.query.language } }">
                      <picture :class="$style['merchant-avatar']">
                        <BaseImage :src="merchantLevel.merchantLogo" :error-src="defaultImg" class-name="is-cover" />
                      </picture>
                    </router-link>
                  </figure>
                  <div class="media-content is-justify-content-center" style="overflow: hidden">
                    <div class="columns is-mobile">
                      <div class="column" style="padding: 0.5rem 0.75rem;border-right: 1px solid #e6e6e6;">
                        <div class="has-text-centered">
                          <div class="has-text-grey is-size-7" style="margin-bottom: 0.5rem">{{ $t('global.MEMBER_LEVEL'/*會員等級*/) }}</div>
                          <div class="has-text-primary">{{merchantLevel.title}}</div>
                        </div>
                      </div>
                      <div class="column" style="padding: 0.5rem 0.75rem;">
                        <div class="has-text-centered">
                          <div class="has-text-grey is-size-7" style="margin-bottom: 0.5rem">{{ $t('global.MEMBERSHIP'/*會籍*/) }}</div>
                          <div>{{ $t('global.MEMBERSHIP_NULL'/*無*/) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="subsection__member-menu">
      <div class="menus is-left">
        <router-link
          :to="{ name: 'member-order', query: { language: $route.query.language, merchant: $route.query.merchant } }"
          :class="{ 'router-link-exact-active': $route.name === 'member-order'
        || $route.name === 'member-order-item'
        || $route.name === 'member-order-ticket' }"
          class="button is-menu-style"
        >{{ $t('global.MEMBER_ORDER'/*預訂紀錄*/) }}</router-link>
        <router-link
          :to="{ name: 'member-prepaid', query: { language: $route.query.language, merchant: $route.query.merchant } }"
          :class="{ 'router-link-exact-active': $route.name === 'member-prepaid'
        || $route.name === 'member-prepaid-description'
        || $route.name === 'member-prepaid-history'
        || $route.name === 'member-prepaid-applicable'
        || $route.name === 'member-prepaid-item' }"
          class="button is-menu-style"
        >{{ $t('global.MEMBER_PREPAID'/*預付方案*/) }}</router-link>
      </div>
    </div>
    <b-modal
      :active.sync="isMerchantPickerActive"
      :width="400"
      :can-cancel="['escape','outside']"
    >
      <MemberMerchantPicker
        :value.sync="merchantLevel"
        :list="merchantLevelList"
        @change="handlerMerchantLevel"
      />
    </b-modal>
    <b-modal
      :active.sync="isModalMemberSettingActive"
      :width="600"
      :can-cancel="['escape','outside']"
    >
      <ModalMemberSetting @close="isModalMemberSettingActive = false"/>
    </b-modal>
  </div>
</template>
<style lang="scss" module>
  .member {
    align-items: center;
    margin: 0 !important;
    & > div:first-child {
      border-right: 1px solid $color-border-base;;
    }
    // display: flex;
    @include mobile {
      // flex-direction: column-reverse;
    }
    &:not(:last-child) {
      border-bottom: 1px solid $color-border-base;
    }
    &-left {
      display: flex;
      flex-wrap: wrap;
      padding: 1.5rem;
      align-items: stretch;
    }
    &-avatar {
      position: relative;
      box-sizing: content-box;
      display: flex;
      width: 100px;
      height: 100px;
      overflow: hidden;
      background: $grey-lighter;
      border-radius: 100%;
    }
    &-right {
      padding: 1.5rem;
      display: flex;
    }
  }
  .merchant {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    &-avatar {
      position: relative;
      box-sizing: content-box;
      display: flex;
      width: 70px;
      height: 70px;
      overflow: hidden;
      cursor: pointer;
      background: $grey-lighter;
      border-radius: 100%;
    }
    &-content {
      &__level-box {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
        padding-left: 1rem;
      }
      &__level-list {
        .merchant-content__level-item {
          padding-top: 0;
          padding-bottom: 0;
        }
        .merchant-content__level-item:not(:last-child) {
          border-right: 1px solid #e6e6e6;
        }
      }

    }
  }
</style>
